type AvatarSize = 'sm' | 'md' | 'lg'

const SIZE_CLASSES: Record<AvatarSize, string> = {
  sm: 'w-7 h-7 border text-xs',
  md: 'w-14 h-14 border text-lg',
  lg: 'w-36 h-36 border-8 text-4xl',
}

interface AvatarProps {
  thumbnail?: string | null
  firstName: string
  lastName: string
  size?: AvatarSize
  className?: string
}

export const Avatar = ({
  thumbnail,
  firstName,
  lastName,
  size = 'md',
  className,
}: AvatarProps) => (
  <div
    className={`shrink-0 rounded-full border-transparent bg-gradient-orange-fuschia-vertical-reverse bg-origin-border flex items-center justify-center overflow-hidden ${SIZE_CLASSES[size]}${className ? ` ${className}` : ''}`}
  >
    {thumbnail ? (
      <img
        src={thumbnail}
        alt={`${firstName} avatar`}
        className="w-full h-full object-cover"
      />
    ) : (
      <span className="text-white font-bold">
        {`${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()}
      </span>
    )}
  </div>
)
